<template>
  <div>
    <div class="card-body py-3">
      <div v-if="getQvctSurveyResponses.length" class="row">
        <div class="col-md-6 col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-body card-scroll h-400px">
              <template v-for="(response, key) in getQvctSurveyResponses">
                <div @click.prevent="selectedResponse = response.id" class="d-flex flex-stack border px-4 py-3 cursor-pointer rounded" :class="{'border-primary': response.id === selectedResponse}">
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <a href="" class="text-gray-800 text-hover-primary fs-6 fw-bold">Réponse {{ getQvctSurveyResponses.length - key }}</a>
                      <span class="text-muted fw-semibold d-block fs-7">{{ formatDate(response.created_at) }}</span>
                    </div>
                  </div>
                </div>
                <div class="separator separator-dashed my-4"></div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-sm-12">
          <div class="card">
            <div v-if="selectedResponseData" class="card-body card-scroll h-400px">
              <div v-if="selectedResponseData.population" class="card-body py-4 px-3 shadow shadow-sm mb-10">
                <div class="h2 required mb-2"> {{ survey.questions }} </div>
                <div class="fw-bold h6"><span class="fs-4">Réponse: </span>{{ selectedResponseData.population.name }}</div>
              </div>

              <div v-for="(response, key) in selectedResponseData.response_datas" :key="key" class="card-body py-4 px-3 shadow shadow-sm mb-10">
                <div class="h5 required mb-2"> {{ response.form_field.label }} </div>
                <div class="fw-bold h6"><span class="fs-4">Réponse: </span>{{ response.response }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row text-center justify-content-center align-items-center pb-10">
        <div class=" text-center ">
          <div class="pt-8 ">
            <Img filename="empty.png" alt=""
                 class="mw-100 h-150px h-sm-150px" />
          </div>
          <h2 class="fs-2x fw-bolder mb-0">{{ $t('qvct_survey.no_survey_response_found') }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

import {useStore} from "vuex";
import {computed, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import { format } from 'date-fns';
import Img from "@/components/Img.vue";

const store = useStore()
const route = useRoute()

const selectedResponse = ref(null)

const props = defineProps({
  survey: {type: Object, require: true}
})

onMounted(() => {
  loadResponses()
})

const getQvctSurveyResponses = computed(() => store.getters['qvctSurvey/loadQvctSurveyResponses'](route.params.id))

watch(() => getQvctSurveyResponses.value, (value) => {
  if(value && value.length && !selectedResponse.value) {
    selectedResponse.value = value[0]?.id
  }
})

const selectedResponseData = computed(() => getQvctSurveyResponses.value.find(x => x.id === selectedResponse.value))

function formatDate(date){
  return format(date, "dd-MM-yyyy HH:mm")
}

function loadResponses() {
  if(route.params.id) {
    store.dispatch('qvctSurvey/loadQvctSurveyResponses', route.params.id)
  }
}

</script>